module.exports = __webpack_public_path__ + "static/img/icon_drawer.ecda4f40.png";